// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HK4zl","main":"styles_main__EKbbC"};